const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header_base",
    "data-name": "header/base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18,
    height: 18,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "bars-regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.52,2.23H.48A.48.48,0,0,1,0,1.76V.48A.48.48,0,0,1,.48,0h17A.48.48,0,0,1,18,.48V1.76A.48.48,0,0,1,17.52,2.23Zm0,6.39H.48A.49.49,0,0,1,0,8.14V6.86a.49.49,0,0,1,.48-.48h17a.49.49,0,0,1,.48.48V8.14A.49.49,0,0,1,17.52,8.62Zm0,6.38H.48A.48.48,0,0,1,0,14.52V13.24a.48.48,0,0,1,.48-.47h17a.48.48,0,0,1,.48.47v1.28A.48.48,0,0,1,17.52,15Z",
    transform: "translate(0 2)",
    style: {
      fill: "#59550f"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadHamburger);
export default __webpack_public_path__ + "static/media/head-hamburger.a44ffcddb5c78eda5985dd125a5fe4d7.svg";
export { ForwardRef as ReactComponent };